module.exports = __webpack_public_path__ + "img/21.2a949ff2.png";